import { render, staticRenderFns } from "./center_6.vue?vue&type=template&id=e9c1d960&scoped=true&"
import script from "./center_6.vue?vue&type=script&lang=js&"
export * from "./center_6.vue?vue&type=script&lang=js&"
import style0 from "./center_6.vue?vue&type=style&index=0&id=e9c1d960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c1d960",
  null
  
)

export default component.exports